<template>
  <component :is="componentFile" :component="component" :preview="preview" :id="component.domId">
  </component>
</template>
<script>
export default {
  props: {
    vueName: {
      type: String,
      required: true,
      default: () => null
    },
    component: {
      type: Object,
      default () {
        return {}
      }
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      componentFile: null
    }
  },
  mounted () {
    this.componentFile = this.renderComp
  },
  methods: {
    renderComp () {
      this.componentFile = (resolve) => ({
        component: import(`../templates/${this.getFilePath(this.component.platform || 0)}/${this.vueName}/index.vue`),
        loading: { template: '<div style="height: 100%; width: 100%; display: table;"><div style="display: table-cell; vertical-align: middle; text-align: center;"><div>加载中</div></div></div>' },
        error: { template: '<div style="height: 100%; width: 100%; display: table;"><div style="display: table-cell; vertical-align: middle; text-align: center;"><div>加载错误</div></div></div>' },
        delay: 500,
        timeout: 10000
      })
    },
    getFilePath (val) {
      let path = ''
      switch (val) {
        case 1:
          path = 'pc'
          break
        case 2:
          path = 'wap'
          break
        default:
          path = 'wap'
          break
      }
      return path
    }
  }
}
</script>
